export default __webpack_public_path__ + "static/media/rocket_anim_13.33d13f7c.png";